<div class="flex-row"
     [hidden]="loading">
    @if (documentGroups.length > 1) {
        <div class="flex-col"
        >
            <mat-nav-list style="width: 250px; margin-right: 25px;">
                <mat-list-item (click)="applyFilter(undefined)"
                               [disableRipple]="true"
                               [ngClass]="!selectedDocumentGroup ? 'isActiveBorder' : 'isNotActiveBorder'">
          <span
              [ngClass]="!selectedDocumentGroup ? 'isActiveText' : 'isNotActiveText'">{{ "All Documents" | uppercase }}
              ({{ getAllDocumentsLength() }})</span>
                </mat-list-item>
                @for (documentgroup of documentGroups | cbSortByPipe: 'name': 'asc'; track documentgroup) {
                    <mat-list-item [disableRipple]="true"
                                   (click)="applyFilter(documentgroup)"
                                   [ngClass]="selectedDocumentGroup && documentgroup.name === selectedDocumentGroup.name ? 'isActiveBorder' : 'isNotActiveBorder'">
            <span
                [ngClass]="selectedDocumentGroup && documentgroup.name === selectedDocumentGroup.name ? 'isActiveText' : 'isNotActiveText'">  {{ documentgroup.name | uppercase }}
                ({{ getGroupLength(documentgroup.id) }})</span>
                    </mat-list-item>
                }
            </mat-nav-list>
        </div>
    }
    <div class="flex-col flex">
        <div class="cb-table cb-margin-top">
            <mat-table [dataSource]="dataSource"
                       matSort
                       [matSortActive]="COLUMN_NAMES.DateUploaded"
                       matSortDirection="desc">

                <!-- Checkbox Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.Checkbox"
                              sticky>
                    <mat-header-cell *matHeaderCellDef
                                     class="select-actions-col">
                        <button mat-icon-button
                                [matMenuTriggerFor]="checkedMenu"
                                [matTooltip]="documentActionsTooltip()"
                                class="checkbox-menu"
                                (click)="$event.stopPropagation()"
                                [disabled]="selectedDocuments?.length < 1">
                            <mat-icon>playlist_add_check</mat-icon>
                        </button>
                        <mat-menu #checkedMenu="matMenu">
                            <button mat-menu-item
                                    (click)="toggleAllChecked($event)">
                                <mat-icon>done_all</mat-icon>
                                <span>&nbsp;{{ toggleAllLabel() }}</span>
                            </button>
                            <button mat-menu-item
                                    (click)="downloadAllChecked()">
                                <mat-icon>file_download</mat-icon>
                                <span>&nbsp;{{ downloadAllLabel() }}</span>
                            </button>
                        </mat-menu>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"
                              class="select-actions-col">
                        <div class="center-center flex-fill">
                            <mat-checkbox [disabled]="!element?.document?.id || element?.document?.isDeleted"
                                          [matTooltip]="(!element?.document?.id || element?.document?.isDeleted) ? 'Document Upload Required' : ''"
                                          [(ngModel)]="checkedDocumentIds[element.id]"
                                          [ngModelOptions]="{ standalone: true}">
                            </mat-checkbox>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Prefix Column -->
                @for (extraColumn of prefixColumns; track extraColumn) {
                    <ng-container
                        [cdkColumnDef]="extraColumn.col">
                        <mat-header-cell *cdkHeaderCellDef>{{ extraColumn.label }}
                        </mat-header-cell>
                        <mat-cell *cdkCellDef="let element">
                            <dl>
                                @for (prop of extraColumn.props; track prop) {
                                    <dd class="mat-body-2"
                                    >{{ element[prop] }}
                                    </dd>
                                }
                            </dl>
                        </mat-cell>
                    </ng-container>
                }

                <!-- Name Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.Name">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Name
                        <cb-sortable-header-cell [sort]="sort"
                                                 [cell]="COLUMN_NAMES.Name"></cb-sortable-header-cell>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        @if (isLinkedDocument(element)) {
                            <cb-info-popup
                                [icon]="'linked'"
                                [tooltip]="'This is a Linked Document'">
                            </cb-info-popup>
                        }
                        @if (element.document) {
                            <cb-info-popup
                                [label]="element.document.name"
                                [tooltip]="element.document.description">
                            </cb-info-popup>
                        }
                    </mat-cell>
                </ng-container>

                <!-- Type Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.FileType">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Type
                        <cb-sortable-header-cell [sort]="sort"
                                                 [cell]="COLUMN_NAMES.FileType"></cb-sortable-header-cell>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <cb-info-popup [label]="element.documentType.label"
                                       [tooltip]="element.documentType.description">
                        </cb-info-popup>
                    </mat-cell>
                </ng-container>

                <!-- Renewal Column -->
                @if (!hideRenewalColumn) {
                    <ng-container
                        [matColumnDef]="COLUMN_NAMES.Renewal">
                        <mat-header-cell *matHeaderCellDef
                                         mat-sort-header>
                            Renewal
                            <cb-sortable-header-cell [sort]="sort"
                                                     [cell]="COLUMN_NAMES.Renewal"></cb-sortable-header-cell>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
              <span>
                {{
                      element.document && element.document.renewalDate
                          ? (element.document.renewalDate | date: "dd MMM yyyy")
                          : "N/A"
                  }}
              </span>
                        </mat-cell>
                    </ng-container>
                }

                <!-- Status Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.Status">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Status
                        <cb-sortable-header-cell [sort]="sort"
                                                 [cell]="COLUMN_NAMES.Status"></cb-sortable-header-cell>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.documentStatus | cbEnumToLabel: DOCUMENT_STATUS_ENUM }}
                    </mat-cell>
                </ng-container>

                <!-- Date Uploaded -->
                <ng-container [matColumnDef]="COLUMN_NAMES.DateUploaded">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Date Uploaded
                        <cb-sortable-header-cell [sort]="sort"
                                                 [cell]="COLUMN_NAMES.DateUploaded"></cb-sortable-header-cell>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element?.document?.updatedDate | date:'dd MMM yyyy hh:mm:ss a' | cbDasher }}
                    </mat-cell>
                </ng-container>

                <!-- Reviews Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.Reviews">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Reviews
                        <cb-sortable-header-cell [sort]="sort"
                                                 [cell]="COLUMN_NAMES.Reviews"></cb-sortable-header-cell>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        @if (element.document) {
                            <span>
                @for (approvalStatus of element.document.approvalStatuses; track approvalStatus) {
                    <cb-info-popup
                        [label]="approvalStatus.needsApprovalByTag"
                        [tooltip]="getReviewComment(approvalStatus)"
                        [icon]="getReviewIcon(approvalStatus)">
                  </cb-info-popup>
                }
              </span>
                        }
                    </mat-cell>
                </ng-container>

                <!-- Actions Column -->
                <ng-container [matColumnDef]="COLUMN_NAMES.Actions"
                              stickyEnd>
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        @if (!isRowDisabled(element)) {
                            <div>
                                @if (!isActionMenuHidden(element)) {
                                    <button [matMenuTriggerFor]="menu"
                                            mat-icon-button
                                            matTooltip="Edit"
                                            matTooltipPosition="right"
                                            [disabled]="false"
                                    >
                                        <mat-icon>more_horiz</mat-icon>
                                    </button>
                                }
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item
                                            (click)="viewDocumentDetails(element)">
                                        <mat-icon>help_outline</mat-icon>
                                        <span> View Details</span>
                                    </button>
                                    @if (canViewHistory(element)) {
                                        <button mat-menu-item
                                                (click)="viewDocumentHistory(element)">
                                            <mat-icon>history</mat-icon>
                                            <span> View History</span>
                                        </button>
                                    }
                                    <button mat-menu-item
                                            (click)="downloadDocument(element)">
                                        <mat-icon>file_download</mat-icon>
                                        <span>Download</span>
                                    </button>
                                    @if (canEdit(element)) {
                                        <button mat-menu-item
                                                (click)="editDocumentDetails(element)">
                                            <mat-icon>mode_edit</mat-icon>
                                            <span>Edit Details</span>
                                        </button>
                                    }
                                    @if (canReview(element)) {
                                        <button mat-menu-item
                                                (click)="reviewDocument(element)">
                                            <mat-icon>rate_review</mat-icon>
                                            <span>Review Document</span>
                                        </button>
                                    }
                                    @if (canUpload(element)) {
                                        <button mat-menu-item
                                                (click)="uploadDocument(element)">
                                            <mat-icon>file_upload</mat-icon>
                                            <span>Upload</span>
                                        </button>
                                    }
                                    @if (canDelete$(element) | async) {
                                        <button mat-menu-item
                                                (click)="deleteDocument(element)">
                                            <mat-icon>delete</mat-icon>
                                            <span>Delete File</span>
                                        </button>
                                    }
                                </mat-menu>
                            </div>
                        }
                        @if (isUploadOnly(element)) {
                            <button
                                mat-icon-button
                                matTooltip="Upload"
                                matTooltipPosition="right"
                                (click)="uploadDocument(element)">
                                <mat-icon>file_upload</mat-icon>
                            </button>
                        }
                        @if (canDeleteStub$(element) | async) {
                            <button
                                mat-icon-button
                                matTooltip="Delete stub"
                                matTooltipPosition="right"
                                (click)="deleteStub(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                        @if (isLinkedDocument(element)) {
                            <button
                                mat-icon-button
                                matTooltip="Upload"
                                matTooltipPosition="right"
                                (click)="downloadDocument(element)">
                                <mat-icon>file_download</mat-icon>
                            </button>
                        }
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row [class.table-disabled]="isRowDisabled(row)"
                         [class.highlight]="row.id == documentId"
                         *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
        </div>
        @if (!loading && selectedDocuments.length < 1) {
            <cb-info-message message="There are no Documents found"
            >
            </cb-info-message>
        }
    </div>
</div>
@if (loading) {
    <cb-loading-spinner></cb-loading-spinner>
}
